import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { ApiUrl } from '@api/ApiUtils';

interface CompanyTag {
  id: number;
  name: string;
}

interface CompanyTagsResponse {
  tags: CompanyTag[];
}

export const companyTagsQueryKey = (companyId: number | undefined) => ['companies', companyId, 'tags'];

export const useGetCompanyTags = ({ companyId, enabled = true }: { companyId: number | undefined; enabled?: boolean }) => {
  return useQuery({
    enabled: !!companyId && enabled,
    queryFn: async () => {
      const response = await axios.get<CompanyTagsResponse>(
        ApiUrl(`/companies/${companyId}/tags`)
      );

      return (response.data.tags || []).map(tag => ({
        label: tag.name,
        value: tag.name,
      }));
    },
    queryKey: companyTagsQueryKey(companyId),
  });
};
